import React from 'react';

export default function IconSvg() {
  return <div>svg</div>;
}
export function IconPlus({ color, width, height }: { color?: string; width?: number; height?: number }) {
  return (
    <svg
      width={width ? width : 16}
      height={height ? height : 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8H12M8 4V12"
        stroke={color ? color : 'var(--colBlack)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconSubBullet({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
      <path d="M1 3V9H5" stroke={color ? color : 'var(--colGray5)'} strokeLinecap="square" />
    </svg>
  );
}

export function IconArrowRight({ width, height, color }: { color: string; width?: number; height?: number }) {
  return (
    <svg
      width={width ? width : 16}
      height={width ? width : 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 3.5L10.25 8L5.75 12.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconArrowDown({ color, width, height }: { color: string; width?: number; height?: number }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : 16}
        height={width ? width : 16}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.5 6L8 10.5L12.5 6"
          stroke={color ? color : 'var(--colBlack)'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconArrowUp({ color, width, height }: { color: string; width?: number; height?: number }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : 16}
        height={width ? width : 16}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.5 10L8 5.5L12.5 10"
          stroke={color ? color : 'var(--colBlack)'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconSelectArrowDown({ color, width, height }: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <path d="M3.5 6L8 10.5L12.5 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </>
  );
}
// 좋아요 아이콘
export function IconLiked({ islike }: { islike: boolean }) {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.5" y="7" width="3" height="6" stroke={islike ? 'var(--colBlack)' : 'var(--colWhite)'} />
        <path
          d="M6.62982 6.15264L5.5 7V13H11.6529C12.1417 13 12.5589 12.6466 12.6393 12.1644L13.3059 8.1644C13.4075 7.55487 12.9375 7 12.3195 7H9.5L9.84058 6.31883C10.2647 5.47057 10.3555 4.49413 10.0949 3.58223C9.88387 2.84355 8.8751 2.74979 8.53153 3.43693L7.98645 4.52711C7.66655 5.16691 7.20208 5.72344 6.62982 6.15264Z"
          stroke={islike ? 'var(--colBlack)' : 'var(--colWhite)'}
        />
      </svg>
    </>
  );
}
// 싫어요 아이콘
export function IconUnLiked({ isunlike }: { isunlike: boolean }) {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10.5" y="3.5" width="3" height="6" stroke={isunlike ? 'var(--colBlack)' : 'var(--colWhite)'} />
        <path
          d="M4.34713 3.5H10.5V9.5L9.37018 10.3474C8.79792 10.7766 8.33346 11.3331 8.01355 11.9729L7.46847 13.0631C7.1249 13.7502 6.11613 13.6565 5.90508 12.9178C5.64453 12.0059 5.73528 11.0294 6.15942 10.1812L6.5 9.5H3.68046C3.06252 9.5 2.59248 8.94513 2.69407 8.3356L3.36073 4.3356C3.4411 3.85341 3.85829 3.5 4.34713 3.5Z"
          stroke={isunlike ? 'var(--colBlack)' : 'var(--colWhite)'}
        />
      </svg>
    </>
  );
}
// 검색 아이콘
export function IconSearch({ color, width, height }: { color: string; width: number; height: number }) {
  return (
    <svg
      width={width ? width : 24}
      height={height ? height : 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        stroke={color ? color : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
// 장바구니 아이콘
export function IconCart({ color, width, height }: { color: string; width: number; height: number }) {
  return (
    <svg
      width={width ? width : 24}
      height={height ? height : 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_222_2498)">
        <path
          d="M9 11V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V10.9673M10.4 21H13.6C15.8402 21 16.9603 21 17.816 20.564C18.5686 20.1805 19.1805 19.5686 19.564 18.816C20 17.9603 20 16.8402 20 14.6V12.2C20 11.0799 20 10.5198 19.782 10.092C19.5903 9.71569 19.2843 9.40973 18.908 9.21799C18.4802 9 17.9201 9 16.8 9H7.2C6.0799 9 5.51984 9 5.09202 9.21799C4.71569 9.40973 4.40973 9.71569 4.21799 10.092C4 10.5198 4 11.0799 4 12.2V14.6C4 16.8402 4 17.9603 4.43597 18.816C4.81947 19.5686 5.43139 20.1805 6.18404 20.564C7.03968 21 8.15979 21 10.4 21Z"
          stroke={color ? color : 'var(--colBlack)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_222_2498">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
// 찜하기 아이콘
export function IconHeartFill({ width, height }: { width: number; height: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g clipPath="url(#a)">
        <path
          stroke="#191919"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M7.5 9.167V5a2.5 2.5 0 0 1 5 0v4.14M8.667 17.5h2.666c1.867 0 2.8 0 3.514-.363a3.334 3.334 0 0 0 1.456-1.457c.364-.713.364-1.646.364-3.513v-2c0-.934 0-1.4-.182-1.757a1.667 1.667 0 0 0-.728-.728C15.4 7.5 14.933 7.5 14 7.5H6c-.934 0-1.4 0-1.757.182-.313.16-.568.414-.728.728-.182.357-.182.823-.182 1.757v2c0 1.867 0 2.8.364 3.513.32.627.83 1.137 1.456 1.457.713.363 1.647.363 3.514.363Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
// 찜 취소 아이콘
export function IconHeartOutline({ width, height }: { width: number; height: number }) {
  return (
    <svg
      width={width ? width : 20}
      height={height ? height : 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2397_26100)">
        <path
          d="M13.0833 3.33334C15.725 3.33334 17.5 5.81668 17.5 8.13334C17.5 12.825 10.1333 16.6667 10 16.6667C9.86667 16.6667 2.5 12.825 2.5 8.13334C2.5 5.81668 4.275 3.33334 6.91667 3.33334C8.43333 3.33334 9.425 4.09168 10 4.75834C10.575 4.09168 11.5667 3.33334 13.0833 3.33334Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2397_26100">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
// 별점 선택 아이콘
export function IconStarOn({ width, height }: { width?: number; height?: number }) {
  return (
    <svg
      width={width ? width : 14}
      height={height ? height : 14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53512 1.27872C6.71852 0.907095 7.24845 0.907094 7.43185 1.27872L8.9244 4.30294C8.99723 4.45052 9.13801 4.5528 9.30087 4.57646L12.6383 5.06142C13.0484 5.12101 13.2122 5.625 12.9154 5.91427L10.5004 8.2683C10.3826 8.38317 10.3288 8.54867 10.3566 8.71087L10.9267 12.0348C10.9968 12.4433 10.5681 12.7547 10.2012 12.5619L7.21616 10.9925C7.07049 10.916 6.89648 10.916 6.75081 10.9925L3.76573 12.5619C3.39891 12.7547 2.97019 12.4433 3.04025 12.0348L3.61035 8.71087C3.63817 8.54867 3.5844 8.38317 3.46655 8.2683L1.05157 5.91427C0.754807 5.625 0.918561 5.12101 1.32867 5.06142L4.6661 4.57646C4.82896 4.5528 4.96974 4.45052 5.04257 4.30294L6.53512 1.27872Z"
        fill="var(--colPointBlue)"
      />
    </svg>
  );
}
// 별점 아이콘
export function IconStarOff({ width, height }: { width?: number; height?: number }) {
  return (
    <svg
      width={width ? width : 14}
      height={height ? height : 14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53512 1.27872C6.71852 0.907095 7.24845 0.907094 7.43185 1.27872L8.9244 4.30294C8.99723 4.45052 9.13801 4.5528 9.30087 4.57646L12.6383 5.06142C13.0484 5.12101 13.2122 5.625 12.9154 5.91427L10.5004 8.2683C10.3826 8.38317 10.3288 8.54867 10.3566 8.71087L10.9267 12.0348C10.9968 12.4433 10.5681 12.7547 10.2012 12.5619L7.21616 10.9925C7.07049 10.916 6.89648 10.916 6.75081 10.9925L3.76573 12.5619C3.39891 12.7547 2.97019 12.4433 3.04025 12.0348L3.61035 8.71087C3.63817 8.54867 3.5844 8.38317 3.46655 8.2683L1.05157 5.91427C0.754807 5.625 0.918561 5.12101 1.32867 5.06142L4.6661 4.57646C4.82896 4.5528 4.96974 4.45052 5.04257 4.30294L6.53512 1.27872Z"
        fill="var(--colGray3)"
      />
    </svg>
  );
}
// 닫기(close) 아이콘
export function IconClose({
  width,
  height,
  color,
  clickEvent,
}: {
  width?: number;
  height?: number;
  color?: string;
  clickEvent?: any;
}) {
  return (
    <svg
      width={width ? width : 24}
      height={height ? height : 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        clickEvent();
      }}
    >
      <g clipPath="url(#clip0_149_809)">
        <path
          d="M6 6L18 18M18 6L6 18"
          stroke={color ? color : 'var(--colBlack)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_149_809">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

// 다운로드 아이콘
export function IconDownload({ width, height, color }: { width?: number; height?: number; color?: string }) {
  return (
    <svg
      height={height ? height : 24}
      width={width ? width : 24}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99977 13.1818V3M9.99977 13.1818L6.92285 10.0649M9.99977 13.1818L13.0767 10.0649"
        stroke={color ? color : 'var(--colWhite)'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M2 13.1816V14.9998C2 16.1044 2.89543 16.9998 4 16.9998H16C17.1046 16.9998 18 16.1044 18 14.9998V13.1816"
        stroke={color ? color : 'var(--colWhite)'}
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
// 쿠폰 발급 완료 아이콘
export function IconCouponComplete({ width, height, color }: { width?: number; height?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : 20}
      height={height ? height : 20}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66667 10.2778L8.71795 12.5L13.3333 7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
        stroke={color ? color : 'var(--colWhite)'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
